import axios from "axios";


function getAll(listRole){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/quyentruycap/public/getall",listRole);//listRole=["ALL","ROLE_NHANVIEN"] size là 2 dùng để set cho 1 Role
};

function checkAll(listRole){
  return axios.post(process.env.REACT_APP_URL_SERVER+"/cus/quyentruycap/public/checkall",listRole);//listRole=["ALL","ROLE_NHANVIEN","ROLE_QUANLY"]
};

const quyenTruyCapService={
  getAll,
  checkAll,
};

export default quyenTruyCapService;
